import React from 'react';
import { Col } from 'react-bootstrap';
import Skeleton from '../../common/skeleton';

const LeftSection = () => {
  return (
    <>
      <Col sm={3}>
        <div className="secondary-background profile-section d-flex d-md-block">
          <div className="profile-image text-center mx-auto">
            <Skeleton
              height={160}
              width={160}
              count={1}
              circle={true}
              containerClassName={'skeleton-image-circle'}
            />
          </div>
          <div className="other-info ml-4 ml-md-0">
            <p className="age-gender paragraph-font primary-text">
              <Skeleton
                height={12}
                count={1}
                containerClassName={'name-address-info'}
              />
            </p>
            <p className="paragraph-font primary-text">
              <Skeleton
                height={12}
                width={100}
                count={1}
                containerClassName={'name-address-info'}
              />
              <Skeleton
                height={12}
                count={1}
                containerClassName={'name-address-info'}
              />
            </p>
            <p className="paragraph-font primary-text">
              <Skeleton
                height={12}
                width={100}
                count={1}
                containerClassName={'name-address-info'}
              />
              <Skeleton
                height={12}
                count={1}
                containerClassName={'name-address-info'}
              />
            </p>
            <p className="paragraph-font primary-text">
              <Skeleton
                height={12}
                width={150}
                count={1}
                containerClassName={'name-address-info'}
              />
              <Skeleton
                height={12}
                width={100}
                count={3}
                containerClassName={'name-address-info'}
              />
            </p>
          </div>
        </div>
      </Col>
    </>
  );
};

export default LeftSection;
